export enum EoiContractConditions {
  SUBJECT_TO_FINANCE = "subjectToFinance",
  FINANCE_STATUS = "financeStatus",
  FIRB = "FIRB",
  OTHER_CONDITIONS = "otherConditions",
}
